// extracted by mini-css-extract-plugin
export default {"root":"Spinner_root__-lsMd","rotation":"Spinner_rotation__HGbN4"};